import { ShieldCheck } from "lucide-react";
import { TRUST_ITEMS } from "../data/content";

export const TrustBar = () => (
  <div data-testid="trust-bar" className="relative bg-royal border-y border-gold/20">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <div className="flex md:justify-center items-center gap-0 overflow-x-auto no-scrollbar py-5 md:py-6 snap-x">
        {TRUST_ITEMS.map((item, i) => (
          <div key={item} className="flex items-center shrink-0 snap-start">
            <div className="flex items-center gap-2.5 px-6">
              <ShieldCheck size={15} strokeWidth={1.5} className="text-gold shrink-0" />
              <span className="text-[13px] tracking-[0.08em] uppercase text-ivory/85 whitespace-nowrap font-light">
                {item}
              </span>
            </div>
            {i < TRUST_ITEMS.length - 1 && <span className="w-px h-4 bg-gold/25" aria-hidden="true" />}
          </div>
        ))}
      </div>
    </div>
  </div>
);
